import React, { useEffect, useState } from "react";
import VideoSelfLearning from "./VideoSelfLearning";
import useSelfLearningContent from "./useSelfLearningContent";
import InstructionBlock from "../../Quiz/InstructionBlock/InstructionBlock";
import { ReactComponent as SelfLearningImage } from "../../../assets/images/no-pdf.svg";
import { useCourseContent, useStyles, useTranslations } from "sdk/custom-hooks";
import { useTheme } from "../../../constants/themeProvider";
import { Box, Typography, useMediaQuery } from "@material-ui/core";
import { ReactComponent as Live } from "../../../assets/images/livecourse.svg";
import { ReactComponent as PointsIcon } from "../../../assets/images/points.svg";
import PropTypes from 'prop-types';
import CTabs from "../CTabs";
import SelfLearningCard from "../SelfLearningCard";
import LiveClassCard from "../LiveClassCard";
import QuizListSection from "../../QuizList/QuizListSection";
import { useDispatch, useSelector } from "react-redux";
import CertificateCard from "../CertificateCard";
import NoData from "../../common/Nodata/noData";
import moment from "moment";
import { getSelfLearningAction } from "sdk/actions/getSelfLearningAction";
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useTheme as useMuiTheme } from "@material-ui/core/styles";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import LockIcon from '@material-ui/icons/Lock';
import { ReactComponent as GreenTick } from "../../../assets/images/greenTick.svg";
import { ColorsConstant } from "../../../constants/colorConstant";
import { setCourseProgress } from "sdk/actions/getCourses";
import { courseCertificateListAction } from "sdk/actions/certificateAddResponse";

function LinearProgressWithLabel({ value = 0, isMobile, primaryColor, t }) {
  const overallProgress = Math.round(value);

  return (
    <Box width="100%" display="flex" alignItems="center" sx={{ gap: '10px' }}>
      {overallProgress <= 99 ? (
        <>
          <Box width={isMobile ? "18px" : "24px"}>
            <CircularProgressbar value={overallProgress} styles={{ path: { stroke: primaryColor, strokeWidth: '10px' } }}/>
          </Box>
          <Typography variant="inherit" sx={{ display: 'flex', color: '#000000DE' }}>
            {overallProgress}% {t('Completed')}
          </Typography>
        </>
      ) : (
        <Box style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
          <GreenTick/>
          <Typography variant="inherit" style={{color: '#2E7D32', fontWeight: '600'}}>{overallProgress}% {t('Completed')}</Typography>
        </Box>
      )}
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  value: PropTypes.number,
  isMobile: PropTypes.bool,
  primaryColor: PropTypes.string,
  t: PropTypes.func.isRequired,
};

function SelfLearningContent(props) { // NOSONAR
  const {
    setSubmittedTest,
    showEvaluationTest,
    selectedCourseId,
    subject_id,
    topic_id,
    activeItem,
    coursePercentage,
    videoRefresh,
    pdfOpen,
    setActiveItem,
    courseName,
    sectionId,
    setShowCourseModalAfterQuiz,
    setSuppressCourseModal,
    isCourseExpired,
    neverExpired,
    showInstructions,
    subjectDetail,
    courseDescription,
    tabBarList,
    selectedTab,
    handleTabChange,
    selectedIndex,
    onVideoRefresh,
    onPdfOpen,
    setSectionNumber,
    setSectionName,
    setNextClick,
    openPdfViewer,
    setCourseDataList,
    setSelectedSubmenu,
    selectedSubmenu,
    currentSectionIndex,
    isDropdownOpen,
    setIsDropdownOpen,
    setCurrentSectionIndex,
    currentDataIndex,
    setCurrentDataIndex,
    setIsDropDown,
    sectionChanged,
    setSectionChanged,
    setShowEvaluationTest,
    sectionName,
    handleUpdateCourseProgress,
    onQuizCardClick,
    showInstructionScreen,
    setdownloadCertificateButton,
    downloadCertificateButton,
  } = props;
  const theme = useTheme();
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));
  const isEvaluationView = Boolean(showEvaluationTest);
  const styles = {
    selfLearningImg: {
      '@media (max-width:959px)': {
        height: '18.3rem'
      } 
    },
    courseInfo: {
      borderRadius: '8px',
      padding: '24px',
      border: '1px solid #E9E9EB',
      marginBottom: '14px',
      background: ColorsConstant.white,
    },
    courseTitle: {
      color: '#1A1B1E',
      fontWeight: '600',
      fontSize: '20px',
      '@media (max-width: 767px)': {
        fontSize: 14
      },
      
    },
    courseText: {
      color: '#000000',
      fontWeight: '400',
      fontSize: '14px',
      margin: 0,
      '& > p': {
        fontSize: isMobile ?  '12px' : '14px',
        margin: 0,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      }
    },
    tagWrapper: {
      display: 'flex', 
      gap: '10px', 
      marginTop: 20,
    },
    alignCourseData: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 15
    },
    courseTags: {
      border:'1px solid #E7EBEE',
      color: theme?.primaryColor,
      display: 'flex',
      padding: '0px 9px',
      alignItems: 'center',
      borderRadius: '4px',
      cursor: 'default',
      fontSize: isMobile ? '12px' : '14px',
    },
    progressLayout: {
      borderRadius: '0px !important',
      backgroundColor: '#ffffff54',
      '& > div': {
        backgroundColor: '#FFFFFF !important'
      },
    },
    mainTabHeading: {
      margin: '30px 0px 10px 0px', 
      fontWeight: '500',
      '@media (max-width: 767px)': {
        fontSize: 16
      }
    },
    pointsBoxParent: {
      display: 'flex', alignItems: 'center',background: '#FFFDE7' , border: '1px solid #FFF176', borderRadius: '4px', padding: '0px 9px' 
    },
    pointsBoxAlign: {
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    },
    points1: {
      fontSize: isMobile ? '12px' : '14px', fontWeight: '600', paddingLeft: '4px', color: `${theme?.primaryColor}`
    },
    points2: {
      fontSize: isMobile ? '12px' : '14px', fontWeight: '600', color: '#FFB703'
    },
    expiringOnDiv: {
      display: 'flex', alignItems: 'center', gap: '5px'
    },
    expiringClockIcon: {
      fill: '#616161', height: '20px', width: '20px'
    },
    expiringOnText: {
      fontSize: isMobile ? '12px' : '14px', color: `${theme?.primaryColor}`
    },
    courseProgressDiv: {
      position: 'absolute', right: '24px', fontWeight: 500
    },
    mobileCourseProgressDiv: {
      marginTop: '16px', display: 'flex', justifyContent: 'space-between'
    },
    mobileCourseProgressText: {
      fontWeight: 500, fontSize: isMobile ? '12px' : '14px'
    },
    selfLearningtabsDiv: {
      border: isEvaluationView ? 'none' : "1px solid #E9E9EB", borderRadius: "8px", paddingBottom: isEvaluationView ? 0 : '14px', background: ColorsConstant.white
    },
    selfLearningScroll: {
      maxHeight:'calc(60dvh - 80px)', overflowY: 'auto'
    }
  }
  const classes = useStyles(styles)();
  const t = useTranslations();
  const {
    playerRef,
    defaultVideo,
    currentVideo,
    videoPlayback,
    setVideoPlayback,
    handleVideoPlayback,
    handleVideoOnReady,
    showPopup,
    closePopup,
    handleResume,
    handleStartFromBeginning,
    callProgressApi,
    videoPlayerControls,
    showComponent,
    toggleInstructionBox,
    startQuiz,
    quizIsStarted,
    isVideoLoaded,
    certificateUnlocked,
    isLoadingSelf,
  } = useSelfLearningContent(props);

  const [quiz, setQuiz] = useState([]);
  const dispatch = useDispatch();
  const [activeIndex, setActiveIndex] = useState(null);
  const [refresh, setRefresh] = useState(true);
  const handleRefresh = () => setRefresh(!refresh);
  const { content } = useCourseContent(selectedCourseId, subject_id, topic_id, refresh);
  const { data: courseDetail } = content;
  const [mySectionData, setMySectionData] = useState([]);
  const [quizAttemptsCount, setQuizAttemptsCount] = useState(0);
  const [certificateData, setCertificateData] = useState([]);
  const isCertCompleted = certificateData && certificateData?.isCompleted === true;

  const [currentActiveSection, setCurrentActiveSection] = useState(activeItem?.data);
  const settingsData = useSelector((state) => state.settingsReducers.settingsData?.data);
  let learningData = useSelector((state) => state.selfLearningReducers);
  let selfLearningData = learningData.selfLearningData;

  useEffect(() => {
    if (!isLoadingSelf) {
      const evaluationTestData = mySectionData?.data?.evaluationTest || selfLearningData?.data?.evaluationTest;
      if (evaluationTestData) {
        setQuiz(evaluationTestData);
      }
    }
}, [courseDetail, mySectionData, isLoadingSelf]);

  useEffect (() => {
    if (coursePercentage !== undefined && coursePercentage !== null) {
      dispatch(setCourseProgress(coursePercentage));
    }
  },[coursePercentage])

  useEffect(() => {
    const quizAttemptsValue = settingsData?.data?.[0] ? settingsData?.data?.[0]?.customization?.quizAttempts : 3;
    setQuizAttemptsCount(quizAttemptsValue);
  },[settingsData]);

  useEffect(() => {
    getCourseSectionApiData();
  }, [selectedCourseId, videoRefresh, pdfOpen, courseDetail]);


  const getCourseSectionApiData = async () => {
    try {
      if (selectedCourseId !== undefined && selectedCourseId !== null) {
        dispatch(getSelfLearningAction(selectedCourseId)).then((res) => {
            setMySectionData(res);
            if (!activeItem && res !== undefined) {
                setActiveItem({
                  data:res?.data?.section[0],
                  sectionData:res
                });
            }
        });
      }
    } catch (error) {
        console.log('Error - ', error.message);
    }
  };

  useEffect(() => {
    if (mySectionData?.data?.courseId?._id) {
      dispatch(courseCertificateListAction(mySectionData?.data?.courseId?._id)).then((res) => {
        if (res?.data?.length) {
          setCertificateData(res?.data[0]);
        }
      });
    }
  }, [mySectionData?.data?.courseId?._id]);

  const completionDate = activeItem?.sectionData?.completedOnDate;
  const assignedEndDate = activeItem?.sectionData?.assignedCourseEndDate;
  const hasCompletedCourse = Boolean(completionDate) && !isCourseExpired;

  let courseStatusInfo = null;
  if (!isMobile && !isLoadingSelf) {
    if (hasCompletedCourse) {
      courseStatusInfo = (
        <>
          <Box> <GreenTick style={{height: '16px', display: 'flex'}}/> </Box>
          <Typography className={classes.expiringOnText} style={{color: '#2e7d32'}} variant="h6">{`${t('Completed on')} ${moment(completionDate).format("DD-MMM-YYYY")}`}</Typography>
        </>
      );
    } else if (isCourseExpired) {
      courseStatusInfo = (
        <>
          <AccessTimeIcon className={classes.expiringClockIcon} style={{fill: '#d32f2f'}}/>
          <Typography className={classes.expiringOnText} style={{color: '#d32f2f'}} variant="h6">{`${t('Expired on')} ${moment(assignedEndDate).format("DD-MMM-YYYY")}`}</Typography>
        </>
      );
    } else {
      courseStatusInfo = (
        <>
          <AccessTimeIcon className={classes.expiringClockIcon}/>
          <Typography className={classes.expiringOnText} variant="h6">{`${t('EXPIRING ON')} ${moment(assignedEndDate).format("DD-MMM-YYYY")}`}</Typography>
        </>
      );
    }
  }

  if (!showComponent) {
    return null;
  }

  if (defaultVideo === undefined) {
    return (
      currentVideo?.refModel === "Quiz" ? (
        <InstructionBlock
          key={currentVideo?.contentData?._id || currentVideo?.contentData?.id || JSON.stringify(currentVideo?.contentData)}
          quiz={currentVideo?.contentData}
          quizIsStarted={quizIsStarted}
          toggleInstructionBox={toggleInstructionBox}
          startQuiz={startQuiz}
          certificateUnlocked={certificateUnlocked}
          courseName={courseName}
          sectionId={sectionId}
          setSubmittedTest={setSubmittedTest}
          setShowCourseModalAfterQuiz={setShowCourseModalAfterQuiz}
          coursePercentage={coursePercentage}
          setSuppressCourseModal={setSuppressCourseModal}
          isCourseExpired={isCourseExpired}
          neverExpired={neverExpired}
        />
      ) : <SelfLearningImage alt="default-image" className={classes.selfLearningImg} style={{ width: "100%" }} />
    )
  }
  return (
    <Box>
    {
      showEvaluationTest || showInstructions ? <></> :  <Box className={classes.courseInfo}>
      <Box className={classes.alignCourseData}>
         <Typography className={classes.courseTitle} variant="h4">{subjectDetail?.name || courseName}</Typography>
        {!isMobile && !isLoadingSelf && <Box className={classes.expiringOnDiv}>
          {courseStatusInfo}
        </Box>}
      </Box>
       <Typography className={classes.courseText} variant="h6" dangerouslySetInnerHTML={{ __html: subjectDetail?.description || courseDescription}}></Typography>
      <Box className={classes.tagWrapper}>
        {settingsData?.data?.[0]?.gamification?.enabled && settingsData?.data?.[0]?.gamification?.pointsEnabled && !isCourseExpired && <Box className={classes.pointsBoxParent}>
            <Box className={classes.pointsBoxAlign}>
                <Box className={classes.pointsBoxAlign}><PointsIcon/></Box>
                <Typography variant='inherit' className={classes.points1}>{mySectionData?.userAwardedPoint}</Typography>
                <Typography variant='inherit' className={classes.points2}>/{mySectionData?.courseTotalPoints}</Typography>
            </Box>
        </Box>}
        {subjectDetail?.isSelfLearning && <Box className={classes.courseTags}>{t('SELF LEARNING')}</Box>}
        {subjectDetail?.isLive && <Box className={classes.courseTags}><span className='live-image'><Live/></span><span>{t('live')}</span></Box>}
        {!isMobile && <Box className={classes.courseProgressDiv}>
          <LinearProgressWithLabel value={coursePercentage} isMobile={isMobile} primaryColor={theme?.primaryColor} t={t} />
        </Box>}
      </Box>
      {isMobile && 
        <Box className={classes.mobileCourseProgressDiv}>
          <Box className={classes.mobileCourseProgressText}>
            <LinearProgressWithLabel value={coursePercentage} isMobile={isMobile} primaryColor={theme?.primaryColor} t={t} />
          </Box>
          <Box className={classes.expiringOnDiv}>
            {isCourseExpired ?
            <><AccessTimeIcon className={classes.expiringClockIcon} style={{fill: '#d32f2f'}}/>
            <Typography className={classes.expiringOnText} style={{color: '#d32f2f'}} variant="h6">{`${t('Expired on')} ${moment(assignedEndDate).format("DD-MMM-YYYY")}`}</Typography></>
            :
            <><AccessTimeIcon className={classes.expiringClockIcon}/>
            <Typography className={classes.expiringOnText} variant="h6">{`${t('EXPIRING ON')} ${moment(assignedEndDate).format("DD-MMM-YYYY")}`}</Typography></>}
          </Box>
        </Box>
      }
    </Box>
    }

    <Box className={classes.selfLearningtabsDiv}>
      <CTabs
        nav={tabBarList}
        selectedTab={selectedTab}
        handleTabChange={handleTabChange}
        subjectDetail={subjectDetail}
        mySectionData={mySectionData}
        isCourseExpired={isCourseExpired}
        neverExpired={neverExpired}
        isCertCompleted={isCertCompleted}
      />
      <Box className={selectedIndex === 3 ? undefined : classes.selfLearningScroll}>
      {selectedIndex === 0 && (
        <>
          {Array.isArray(mySectionData?.data?.section) ? mySectionData?.data?.section.map((item, index) => {
            const sectionKey = item?._id || item?.id || item?.title || `section-${item?.sectionNumber || index}`;
            return(<SelfLearningCard key={sectionKey} currentActiveSection={currentActiveSection} setCurrentActiveSection={setCurrentActiveSection}
              setActiveItem={setActiveItem} activeItem={activeItem} index={index} sectionIndex={index} data={item}
              sectionData={mySectionData} activeIndex={activeIndex} setActiveIndex={setActiveIndex}
              onVideoRefresh={onVideoRefresh} videoRefresh={videoRefresh} pdfOpen={pdfOpen} courseId={activeItem?.sectionData?.data?.courseId?._id}
              onPdfOpen={onPdfOpen} 
              courseName={courseName}
              setSectionNumber={setSectionNumber}
              setSectionName={setSectionName}
              setNextClick={setNextClick}
              openPdfViewer={openPdfViewer}
              setCourseDataList={setCourseDataList}
              setSelectedSubmenu={setSelectedSubmenu}
              selectedSubmenu={selectedSubmenu}
              currentSectionIndex = {currentSectionIndex}
              isDropdownOpen={isDropdownOpen}
              setIsDropdownOpen={setIsDropdownOpen}
              setCurrentSectionIndex = {setCurrentSectionIndex}
              currentDataIndex = {currentDataIndex}
              setCurrentDataIndex={setCurrentDataIndex}
              setIsDropDown={setIsDropDown}
              sectionChanged={sectionChanged} 
              setSectionChanged={setSectionChanged}
              showEvaluationTest={showEvaluationTest}
              setShowEvaluationTest={setShowEvaluationTest}
              sectionName={sectionName}
              handleUpdateCourseProgress={handleUpdateCourseProgress}
              isCourseExpired={isCourseExpired}
              />)
          }) : !isLoadingSelf && mySectionData?.data?.section?.length < 1 && <>{t('No Self Learning data found!')}</>}    
        </>
      )}

      {selectedIndex === 1 && (
        isCourseExpired ? (
          <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', opacity: 0.6 }}>
            <LockIcon style={{ fontSize: '48px', color: '#9e9e9e', marginBottom: '12px' }} />
            <Typography style={{ fontSize: '16px', fontWeight: 500, color: '#616161', textAlign: 'center' }}>{t('This course has expired. Live classes are no longer accessible.')}</Typography>
          </Box>
        ) : (
          <Box>
              {mySectionData?.data?.liveClass?.length ? mySectionData?.data?.liveClass.map((item, index) => {
                const liveKey = item?._id || item?.id || item?.title || `live-${item?.startDate || index}`;
                return <LiveClassCard key={liveKey} data={item} sectionData={mySectionData} />
              }) : !isLoadingSelf && mySectionData?.data?.section?.length < 1 && <>{t('No Live Class Found!')}</>}
          </Box>
        )
      )}

      {selectedIndex === 2 && !isLoadingSelf && (
        isCourseExpired ? (
          <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', opacity: 0.6 }}>
            <LockIcon style={{ fontSize: '48px', color: '#9e9e9e', marginBottom: '12px' }} />
            <Typography style={{ fontSize: '16px', fontWeight: 500, color: '#616161', textAlign: 'center' }}>{t('This course has expired. Evaluation tests are no longer accessible.')}</Typography>
          </Box>
        ) : (
          <Box>
              {quiz?.length ? <Box>
                  {quiz?.length ? (
                  <QuizListSection
                      hideViewMore={false}
                      quizSectionList={quiz}
                      showVertical={true}
                      handleRefresh={handleRefresh}
                      startQuiz={startQuiz}
                      course_id={selectedCourseId}
                      onQuizCardClick={onQuizCardClick}
                      showInstructions={showInstructions}
                      showInstructionScreen={showInstructionScreen}
                      progressPercent={mySectionData?.data?.progressPercent}
                      attemptsRemaining={mySectionData?.data?.evaluationTest[0]?.quizAttempts}
                      courseName={courseName}
                      quizTotalAttempts={quizAttemptsCount}
                      certificationToggle={mySectionData?.data?.courseId?.certificationToggle}
                      isUserCertified={isCertCompleted}
                  />
                  ) : (
                  <NoData message={t("no_data")} />
                  )}
              </Box> : !isLoadingSelf && !mySectionData?.data?.evaluationTest && <>{t('No Evaluation Test Found!')}</>}
          </Box>
        )
      )}

      {selectedIndex === 3 && (
        isCourseExpired && !(neverExpired && isCertCompleted) ? (
          <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', opacity: 0.6 }}>
            <LockIcon style={{ fontSize: '48px', color: '#9e9e9e', marginBottom: '12px' }} />
            <Typography style={{ fontSize: '16px', fontWeight: 500, color: '#616161', textAlign: 'center' }}>{t('This course has expired. Certification is no longer accessible.')}</Typography>
          </Box>
        ) : (
          <CertificateCard setdownloadCertificateButton={setdownloadCertificateButton} downloadCertificateButton={downloadCertificateButton} sectionData={mySectionData} />
        )
      )}
      </Box>
    </Box>
      
      {/* Video */}
      {currentVideo?.refModel === "RecordedVideo" && (
        <VideoSelfLearning 
          playerRef={playerRef}
          currentVideo={currentVideo}
          videoPlayback={videoPlayback}
          setVideoPlayback={setVideoPlayback}
          handleVideoPlayback={handleVideoPlayback}
          handleVideoOnReady={handleVideoOnReady}
          videoPlayerControls={videoPlayerControls}
          showPopup={showPopup}
          closePopup={closePopup}
          handleResume={handleResume}
          handleStartFromBeginning={handleStartFromBeginning}
          callProgressApi={callProgressApi}
          isVideoLoaded={isVideoLoaded}
          thumbnail={<SelfLearningImage alt="default-image" style={{ width: "100%" }} />}
        />
      )}
      {/* Quiz Instruction */}
      {currentVideo?.refModel === "Quiz" && (
        <InstructionBlock
          key={currentVideo?.contentData?._id || currentVideo?.contentData?.id || JSON.stringify(currentVideo?.contentData)}
          quiz={currentVideo?.contentData}
          quizIsStarted={quizIsStarted}
          sectionId={sectionId}
          toggleInstructionBox={toggleInstructionBox}
          startQuiz={startQuiz}
          certificateUnlocked={certificateUnlocked}
          setSubmittedTest={setSubmittedTest}
          setShowCourseModalAfterQuiz={setShowCourseModalAfterQuiz}
          coursePercentage={coursePercentage}
          setSuppressCourseModal={setSuppressCourseModal}
          isCourseExpired={isCourseExpired}
          neverExpired={neverExpired}
        />
      )}
    </Box>
  );
}

SelfLearningContent.propTypes = {
  setSubmittedTest: PropTypes.func,
  showEvaluationTest: PropTypes.bool,
  selectedCourseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  subject_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  topic_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  activeItem: PropTypes.any,
  coursePercentage: PropTypes.number,
  videoRefresh: PropTypes.bool,
  pdfOpen: PropTypes.bool,
  setActiveItem: PropTypes.func,
  courseName: PropTypes.string,
  sectionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setShowCourseModalAfterQuiz: PropTypes.func,
  setSuppressCourseModal: PropTypes.func,
  isCourseExpired: PropTypes.bool,
  neverExpired: PropTypes.bool,
  showInstructions: PropTypes.bool,
  subjectDetail: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    isSelfLearning: PropTypes.bool,
    isLive: PropTypes.bool,
  }),
  courseDescription: PropTypes.string,
  tabBarList: PropTypes.array,
  selectedTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleTabChange: PropTypes.func,
  selectedIndex: PropTypes.number,
  onVideoRefresh: PropTypes.func,
  onPdfOpen: PropTypes.func,
  setSectionNumber: PropTypes.func,
  setSectionName: PropTypes.func,
  setNextClick: PropTypes.func,
  openPdfViewer: PropTypes.func,
  setCourseDataList: PropTypes.func,
  setSelectedSubmenu: PropTypes.func,
  selectedSubmenu: PropTypes.any,
  currentSectionIndex: PropTypes.number,
  isDropdownOpen: PropTypes.bool,
  setIsDropdownOpen: PropTypes.func,
  setCurrentSectionIndex: PropTypes.func,
  currentDataIndex: PropTypes.number,
  setCurrentDataIndex: PropTypes.func,
  setIsDropDown: PropTypes.func,
  sectionChanged: PropTypes.bool,
  setSectionChanged: PropTypes.func,
  setShowEvaluationTest: PropTypes.func,
  sectionName: PropTypes.string,
  handleUpdateCourseProgress: PropTypes.func,
  onQuizCardClick: PropTypes.func,
  showInstructionScreen: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  setdownloadCertificateButton: PropTypes.func,
  downloadCertificateButton: PropTypes.bool,
};

export default SelfLearningContent;
